var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 9.50506H14.1264L12.0033 3L9.87357 9.50506L3 9.49846L8.56653 13.5229L6.43679 20.0214L12.0033 16.0035L17.5632 20.0214L15.4401 13.5229L21 9.50506Z",
    fill: "#00B67A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/StarIcon.e5021a9dc2d29447ef9e47cd4d9d25e1.svg";
export { ForwardRef as ReactComponent };